import * as React from "react";
import styled from "styled-components";
import {ConstBreakPoint} from "../../../config/styles_const/styles_const";
import Assets from "../../assets/img/assets";
import HeadlineLarge from "../../common/atom/text/headline_large";
import ParagraphSup from "../../common/atom/text/paragraph_sup";
import AuthApplyClientDemoRegisterForm from "./apply_client_register/auth_apply_client_demo_register_form";
import {AuthWrapper, CreateFormFlex, CreateFormWrapper,} from "./share/auth_share_components";

interface IProps {
    handleApplyClient: (values: any) => void;
}

const AuthApplyClientDemoRegisterComponent: React.FC<IProps> = (props) => {
    const {handleApplyClient} = props;

    return (
        <React.Fragment>
            <AuthWrapper>
                <CreateFormWrapper>
                    <CreateFormFlex>
                        <AuthApplyClientDemoRegisterSide/>
                        <AuthApplyClientDemoRegisterForm onSubmit={handleApplyClient}/>
                    </CreateFormFlex>
                    <ParagraphSup>© Libera Inc.</ParagraphSup>
                </CreateFormWrapper>
            </AuthWrapper>
        </React.Fragment>
    );
};

export default AuthApplyClientDemoRegisterComponent;

const AuthApplyClientDemoRegisterSide: React.FC<{}> = (props) => {
    const {} = props;

    return (
        <Wrapper>
            <CreateFormTitle>アライアンスパートナー</CreateFormTitle>
            <CreateFormImgCenterWrapper>
                <CreateFormImg src={Assets.apply_client_demo}/>
            </CreateFormImgCenterWrapper>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-right: 20px;
        width: 50%;
    }
`;

const CreateFormImgCenterWrapper = styled.div`
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        height: 70%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }
`;

const CreateFormTitle = styled(HeadlineLarge)`
    text-align: center;
    margin-bottom: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        text-align: left;
        margin-bottom: 0;
    }
`;

const CreateFormImg = styled.img`
    width: 400px;
    margin-top: 30px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_apply_client_demo_register.tsx